import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Emit } from "vue-property-decorator";
import BaseMixer from "@/router/views/BaseMixer";
import { interpret } from "xstate";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import clockWorkSearchMachine from "./machines/clockWorkSearchMachine";
import Loader from "@/components/widgets/loader.vue";
import simplebar from "simplebar-vue";
let ClockWorkSearch = /** @class */ (() => {
    let ClockWorkSearch = class ClockWorkSearch extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.machine = clockWorkSearchMachine.withContext({
                skipCount: 0,
                searchCharacters: "",
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
            this.activeIndex = -1;
            this.entryDate = new Date();
            this.cwSearchFocus = false;
            this.searchCharacters = "";
            this.today = new Date();
            this.count = 0;
            this.TotalCount = 0;
            this.spinnerClass = false;
        }
        initialize() {
            this.activeIndex = -1;
            this.searchCharacters = "";
            ClockWorkModule.ClearFilterEntries();
            ClockWorkModule.clearTotalCount();
        }
        clearFilter() {
            this.count = 0;
            this.searchCharacters = "".trim();
            ClockWorkModule.ClearFilterEntries();
            this.send({ type: "CLEAR_SEARCH_CHARACTER" });
        }
        showModal() {
            this.$bvModal.show("cw_search_modal");
            this.getRecentEntries();
        }
        getRecentEntries() {
            this.count = 0;
            this.activeIndex = -1;
            this.send({ type: "GET_RECENT_ENTRIES", skipCount: this.count });
        }
        closeModal() {
            this.count = 0;
            this.initialize();
            this.$bvModal.hide("cw_search_modal");
            this.send({ type: "MAKE_MODAL_DORMANT" });
        }
        send(event) {
            this.machineService.send(event);
        }
        searchDataByFilter() {
            ClockWorkModule.ClearFilterEntries();
            this.count = 0;
            this.activeIndex = -1;
            this.send({ type: "SEARCH_ENTRIES", str: this.searchCharacters, skipCount: this.count });
        }
        loadMore() {
            this.spinnerClass = true;
            this.count = this.searchedEntries != null && this.searchedEntries != undefined ? this.searchedEntries.length : 0;
            this.send({ type: "LOAD_MORE_SEARCH_ENTRIES", str: this.searchCharacters, skipCount: this.count });
            this.setFocusToInputAndSelect("cwSearch");
        }
        loadMoreRecentItems() {
            this.spinnerClass = true;
            this.count = this.searchedEntries != null && this.searchedEntries != undefined ? this.searchedEntries.length : 0;
            this.send({ type: "LOAD_MORE_RECENT_ITEMS", skipCount: this.count });
            this.setFocusToInputAndSelect("cwSearch");
        }
        handleKeyUp(event) {
            const previousIndex = this.activeIndex;
            switch (event.key) {
                case "ArrowDown":
                    this.activeIndex = Math.min(this.activeIndex + 1, this.filteredResults.length - 1);
                    this.scrollActiveIndexIntoView(event, previousIndex);
                    break;
                case "ArrowUp":
                    this.activeIndex = Math.max(this.activeIndex - 1, -1);
                    this.scrollActiveIndexIntoView(event, previousIndex);
                    break;
                case "Enter":
                    if (event.ctrlKey) {
                        if (this.activeIndex !== -1) {
                            const selectedItem = this.filteredResults[this.activeIndex];
                            this.selectItem(selectedItem.startTime);
                        }
                    }
                    else if (this.activeIndex !== -1) {
                        const selectedItem = this.filteredResults[this.activeIndex];
                        if (selectedItem != null) {
                            this.restartEntryFromSearch(selectedItem);
                        }
                    }
                    break;
                default:
                    if (event.key) {
                        this.searchDataByFilter();
                    }
                    break;
            }
        }
        scrollActiveIndexIntoView(event, previousIndex) {
            let targetIndex;
            const scrollContainer = document.getElementById("scroll-activeIndex");
            if (scrollContainer) {
                const items = scrollContainer.getElementsByClassName("cw-search-list-item");
                for (let i = 0; i < items.length; i++) {
                    items[i].classList.remove("active");
                }
                if (this.activeIndex === -1 && event.key === "ArrowUp") {
                    targetIndex = items.length - 1;
                    this.activeIndex = items.length - 1;
                }
                else {
                    targetIndex = this.activeIndex;
                }
                const activeItem = items[targetIndex];
                if (activeItem) {
                    if (targetIndex < items.length) {
                        activeItem.classList.add("active");
                        activeItem.scrollIntoView({ block: "center", behavior: "smooth" });
                    }
                }
                if (event.key === "ArrowDown" && targetIndex == items.length - 1 && previousIndex == targetIndex) {
                    const firstItem = items[0];
                    if (firstItem) {
                        this.activeIndex = -1;
                        firstItem.classList.add("active");
                        firstItem.scrollIntoView({ block: "start", behavior: "smooth" });
                    }
                }
            }
        }
        handleItemClick(index, entryDate) {
            this.activeIndex = index;
            this.closeModal();
            var entry = new Date(entryDate);
            return this.selecteddate(entry);
        }
        selectItem(searchItem) {
            var entry = new Date(searchItem);
            this.closeModal();
            return this.selecteddate(entry);
        }
        convertSecondsToHoursAndMinsFormat(totalSeconds) {
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            if (hours <= 1) {
                return `${hours}hr ${minutes}m`;
            }
            else if (hours > 1) {
                return `${hours}hrs ${minutes}m`;
            }
        }
        convertDateToDateString(entryDate) {
            var day = new Date(entryDate);
            return day.toDateString();
        }
        highlightSearchedItem(text, search) {
            if (!search)
                return text;
            const regex = new RegExp(`(${search})`, "gi");
            return text.replace(regex, "<span class='keyword-highlight'>$1</span>");
        }
        restartEntryFromSearch(searchItem) {
            this.closeModal();
            this.restart(searchItem);
        }
        get totalCount() {
            return ClockWorkModule.totalCount;
        }
        get searchedEntries() {
            return ClockWorkModule.filteredEntries;
        }
        get filteredResults() {
            const filteredEntries = this.searchedEntries.filter((result) => {
                return (result.description.toLowerCase().includes(this.searchCharacters.toLowerCase()) ||
                    result.projectDisplayString.toLowerCase().includes(this.searchCharacters.toLowerCase()) ||
                    result.taskDisplayString.toLowerCase().includes(this.searchCharacters.toLowerCase()));
            });
            return filteredEntries.map((entry) => ({
                ...entry,
                descriptionHighlighted: this.highlightSearchedItem(entry.description, this.searchCharacters),
                projectDisplayStringHighlighted: this.highlightSearchedItem(entry.projectDisplayString, this.searchCharacters),
                taskDisplayStringHighlighted: this.highlightSearchedItem(entry.taskDisplayString, this.searchCharacters),
            }));
        }
        restart(searchItem) { }
        selecteddate(entry) { }
        created() {
            this.initialize();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                if (this.state.matches("modalActive.recentItemsLoaded") || this.state.matches("modalActive.searchResultsLoaded")) {
                    this.spinnerClass = false;
                }
                if (this.state.matches("modalActive.debouncingSearch") || this.state.matches("modalActive.searchingEntries") || this.state.matches("modalActive.checkForSearchCharacters")) {
                    this.spinnerClass = true;
                }
            });
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ClockWorkSearch.prototype, "restart", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ClockWorkSearch.prototype, "selecteddate", null);
    ClockWorkSearch = __decorate([
        Component({
            name: "clockWorkSearch",
            components: {
                Loader,
                simplebar,
            },
        })
    ], ClockWorkSearch);
    return ClockWorkSearch;
})();
export default ClockWorkSearch;
